module.exports = __webpack_public_path__ + "img/background.3a09d05b.jpg";